/**
 * @flow
 */
class Storage {

  constructor() {
    process.env.NODE_ENV !== 'production' && console.log('[Local Storage] initialized.');
  }

  get user() {return this.get('@user')}
  set user(data: Object | null) {this.set('@user', data)}

  get token() {return this.get('@token')}
  set token(data: Object | null) {this.set('@token', data)}

  get menu() {return this.get('@menu')}
  set menu(data: Object | null) {this.set('@menu', data)}

  get(key: string): Object | null {
    try {
      const res = localStorage.getItem(key);
      return res ? JSON.parse(res) : null;
    } catch(error) {
      console.log(error);
      return null;
    }
  }

  set(key: string, data: Object | null) {
    if(data === null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(data));
    }
  }

  unset(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }

  from(data) {
    this.token = data.token;
    this.user = data.user;
    this.menu = data.menu;
  }

}

export default new Storage();
